export type RefTypeBase<T> = {
  type: T;
};

export enum OfferAssignmentRefType {
  ReferralReward = 'ReferralReward',
  ReferralTemplate = 'ReferralTemplate',
}
